import { useEffect, useRef } from 'react';
import { useAppDependencyGraphProvider } from '../../../../context/DependencyGraphProvider';
import { ComputeContextKeys } from '../../../../hooks/computeContext/const';
import { useGlobalAppStateStore } from '../../../../stores/app/GlobalAppStateStore';

/**
 * Watches `navigation.unopenedNotificationsCount` in the global app state store
 * and notifies the dependency graph so that expressions referencing
 * `interfaceRecord.navigation.notifications.unreadCount` re-evaluate.
 */
function useSyncNotificationCount() {
  const unopenedNotificationsCount = useGlobalAppStateStore().hooks.useUnopenedNotificationsCount();
  const {
    actions: { notifyDependencyChange },
  } = useAppDependencyGraphProvider();

  const prevCountRef = useRef(unopenedNotificationsCount);

  useEffect(() => {
    if (prevCountRef.current !== unopenedNotificationsCount) {
      prevCountRef.current = unopenedNotificationsCount;
      notifyDependencyChange({
        id: ComputeContextKeys.INTERFACE_RECORD,
      });
    }
  }, [unopenedNotificationsCount, notifyDependencyChange]);
}

export default useSyncNotificationCount;
